<div class="thumbnail" [class.limit-width]="limitWidth">
  <div *ngIf="(isLoading$ | async)" class="thumbnail-content outer">
    <div class="inner">
      <div class="centered">
        <ds-loading [spinner]="true"></ds-loading>
      </div>
    </div>
  </div>
  <!-- don't use *ngIf="!isLoading" so the thumbnail can load in while the animation is playing -->
  <img *ngIf="(src$ | async) !== null" class="thumbnail-content img-fluid" [ngClass]="{'d-none': (isLoading$ | async)}"
       [src]="(src$ | async) | dsSafeUrl" [alt]="alt | translate" (error)="errorHandler()" (load)="successHandler()">
  <div *ngIf="(src$ | async) === null && (isLoading$ | async) === false" class="thumbnail-content outer" #thumbnailBox>
    <img [src]="placeholderImageUrl$ | async" [alt]="placeholder | translate">
  </div>
</div>
